module.exports = __webpack_public_path__ + "static/media/consulting.7dde91f0.svg";